import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DtcSearchComponent } from './dtc-search/dtc-search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, FeaturesConfigModule, UrlModule, ConfigModule, CmsConfig } from '@spartacus/core';
import { AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, SpinnerModule, StarRatingModule, ProductListModule } from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';
import { DtcSearchGridComponent } from './dtc-search-grid/dtc-search-grid.component';
import { DtcSearchListComponent } from './dtc-search-list/dtc-search-list.component';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { DtcTroubleshootComponent } from './dtc-troubleShoot/dtc-troubleshoot/dtc-troubleshoot.component';



@NgModule({
  declarations: [DtcSearchComponent,DtcSearchListComponent,DtcSearchGridComponent,DtcTroubleshootComponent],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,  
    KbPaginationModule,
    KbPipesModule,

    ConfigModule.withConfig({
      cmsComponents: {
        DTCSearchCMSFlexComponent: {
          component: DtcSearchComponent,
          guards: [SecureGuard]
        },
        DTCLookUpDetailsFlexComponent:{
          component: DtcTroubleshootComponent,
          guards: [SecureGuard]
        }
      }
    } as CmsConfig)

  ]
})
export class KbDtcSearchModule { }
